import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock'

export default {
  mounted: function() {
    const element = this.$refs['scrollElement'] || this.$el

    if (element.nodeName !== "#comment")
      disableBodyScroll(element)
  },

  beforeDestroy: function() {
    const element = this.$refs['scrollElement'] || this.$el

    if (element.nodeName !== "#comment")
      enableBodyScroll(element)
  },

}